import React, { Component } from "react";
import axios from "axios";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import { Redirect, Link } from "react-router-dom";
import Constants from "../App/Variables/Constants";
import EditIcon from "@material-ui/icons/Edit";
import init from "../helpers/WindowToken";

export default class UpdateBanner extends Component {
  state = {
    title: "",
    link: "",
    category_id: "",
    bannerId: "",
    loading: false,
    notification: false,
    redirect: false,
    message: "",
    image: "",
    nextImage: null,
    categories: [],
  };

  componentDidMount() {
    const data = this.props.location?.state?.data;

    this.getCategories();

    if (data) {
      this.setState({
        bannerId: data._id,
        title: data.title || "",
        link: data.link || "",
        category_id: data?.category_id?._id || data?.category_id || "",
        image: data.image || "",
      });
    }
  }

  getCategories = async () => {
    try {
      const response = await axios.get(
        `${Constants.getUrls.getAllCategory}?limit=150`
      );

      this.setState({
        categories: response?.data?.data?.docs || [],
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  updateBanner = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("title", this.state.title);
    fd.append("link", this.state.link);
    fd.append("category_id", this.state.category_id);

    if (this.state.nextImage) {
      fd.append("image", this.state.nextImage);
    }

    try {
      this.setState({
        loading: true,
      });

      if (init() === "success") {
        const resp = await axios.put(
          `${Constants.putUrls.updateBanner}/${this.state.bannerId}`,
          fd
        );

        this.setState({
          loading: false,
          notification: true,
          message: resp.data.message,
        });

        setTimeout(() => {
          this.setState({
            notification: false,
            redirect: true,
          });
        }, 1200);
      }
    } catch (error) {
      this.setState({
        notification: true,
        message: error?.response?.data?.message || "Banner update failed",
      });

      setTimeout(() => {
        this.setState({
          notification: false,
          loading: false,
        });
      }, 2000);
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/banners" />;
    }

    return (
      <Container maxWidth="xl">
        <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h5">Update Banner</Typography>
          </Grid>
        </Grid>

        {this.state.notification ? (
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open
            autoHideDuration={4000}
            message={this.state.message}
          />
        ) : null}

        <div
          style={{
            background: "#5b5757",
            padding: "20px",
            borderRadius: "10px",
            width: "100%",
            boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
            marginTop: "30px",
            marginBottom: "30px",
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div
            style={{
              background:
                "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250))",
              padding: "15px",
              marginTop: "-43px",
              borderRadius: "6px",
              width: "60px",
              textAlign: "center",
              marginBottom: "25px",
            }}
          >
            <EditIcon />
          </div>

          <form onSubmit={this.updateBanner}>
            <Grid container spacing={2}>
              <Grid item sm={4}>
                <TextField
                  onChange={this.handleInput}
                  label="Title"
                  name="title"
                  variant="outlined"
                  required
                  value={this.state.title}
                  style={{ width: "100%" }}
                />
              </Grid>

              <Grid item sm={4}>
                <TextField
                  onChange={this.handleInput}
                  label="Link"
                  name="link"
                  variant="outlined"
                  value={this.state.link}
                  style={{ width: "100%" }}
                />
              </Grid>

              <Grid item sm={4}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>Select Category</InputLabel>
                  <Select
                    value={this.state.category_id}
                    onChange={this.handleInput}
                    name="category_id"
                    label="Select Category"
                  >
                    <MenuItem value="">No Category Redirect</MenuItem>
                    {this.state.categories.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item sm={4}>
                <input
                  type="file"
                  onChange={(e) => {
                    this.setState({ nextImage: e.target.files[0] });
                  }}
                  accept="image/*"
                />
              </Grid>

              <Grid item sm={4}>
                {this.state.image ? (
                  <img
                    src={Constants.imgDomain + this.state.image}
                    alt=""
                    style={{ height: "100px", width: "140px", objectFit: "cover" }}
                  />
                ) : null}
              </Grid>
            </Grid>

            <br />
            <div>
              <Button
                variant="contained"
                type="submit"
                size="small"
                color="primary"
                style={{
                  marginRight: "20px",
                  marginTop: "35px",
                }}
              >
                {this.state.loading ? "Updating..." : "Update Banner"}
              </Button>
              <Link to="/banners" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  style={{ marginRight: "20px", marginTop: "35px" }}
                >
                  Cancel
                </Button>
              </Link>
            </div>
          </form>
        </div>
      </Container>
    );
  }
}
